import { useEffect, useRef, useState } from 'react';
import { useWebSocket } from '../../context/WebSocketContext';
import { traderAPI } from '../context/TraderAuthContext';
import { mergeBinanceCandle } from '../utils/binance';

export const useBinanceHistory = (symbol,timeframe,enabled,quote) => {
  const {isConnected}=useWebSocket();
  const [state,setState]=useState({key:'',candles:[],loading:false,error:false});
  const latest=useRef(quote);latest.current=quote;
  const key=`${symbol}:${timeframe}`;
  useEffect(()=>{
    if(!enabled)return;
    let active=true,pending=false;
    const controller=new AbortController();
    setState({key,candles:[],loading:true,error:false});
    const load=async()=>{
      if(pending)return;pending=true;
      try {
        const {data}=await traderAPI.get(`${process.env.REACT_APP_BACKEND_URL}/api/trader/market-data/history`,{params:{symbol,timeframe},signal:controller.signal});
        if(active)setState({key,candles:mergeBinanceCandle(data.candles.map(row=>({...row,market_source:'binance'})),latest.current?.candle_1m,timeframe),loading:false,error:false});
      }catch {if(active)setState(previous=>({...previous,loading:false,error:true}));}
      finally{pending=false;}
    };
    load();
    const interval=setInterval(()=>{if(document.visibilityState==='visible')load();},15000);
    return()=>{active=false;controller.abort();clearInterval(interval);};
  },[enabled,symbol,timeframe,key,isConnected]);
  useEffect(()=>{
    if(enabled)setState(previous=>previous.key===key&&!previous.loading?{...previous,candles:mergeBinanceCandle(previous.candles,quote?.candle_1m,timeframe)}:previous);
  },[enabled,key,timeframe,quote?.candle_1m?.event_time_ms]);
  return state.key===key?state:{candles:[],loading:enabled,error:false};
};

export const useMarketClock = enabled => {
  const [now,setNow]=useState(Date.now);
  useEffect(()=>{if(!enabled)return;const timer=setInterval(()=>setNow(Date.now()),1000);return()=>clearInterval(timer);},[enabled]);
  return now;
};